import _ from 'lodash';
import { useNavigate } from 'react-router-dom';
import { PATH } from '../../../constants';
import { channels } from '../../../test.data';
import AsideSection from '../../containers/aside/aside.section';
import { v4 as uuid4 } from 'uuid';
import { HStack, VStack } from '../../layouts/stack.layout';
import Avatar from '../../images/avatar';
import Button from '../../button/v2/button';
import { TagsContainer } from '../../containers/tags.container';
import { CHANNELS_TAB_OPTIONS } from '../../navigation/tabs/tab-options';

const tinyChannelKeys = [
  'id',
  'title',
  'backgroundImage',
  'administrator',
  'pinnedMessage',
  'topListners',
  'hasJoined',
  'isPrivate',
  'tags',
];

export default function SuggestedChannels() {
  const path = `/${PATH.CHANNELS}?tab=${CHANNELS_TAB_OPTIONS.RECOMMENDED}`;
  const navigate = useNavigate();
  const recommended = channels
    .filter((channel) => channel.hasJoined === false)
    .map((channel) => ({
      ..._.pick(channel, [...tinyChannelKeys]),
      listenersCount: channel.listeners.length,
    }));
  return (
    <AsideSection path={path} title="suggested channels">
      {recommended.slice(0, 3).map((channel) => (
        <HStack
          onClick={() =>
            navigate(
              `/${PATH.CHANNELS}?tab=${CHANNELS_TAB_OPTIONS.RECOMMENDED}&view_details=true&id=${channel.id}`
            )
          }
          gap="sm"
          key={uuid4()}
          extensions="cursor-pointer w-full items-center py-3 hover:bg-white/[5%] ease-in transition-colors px-[50px]"
          justify="between"
        >
          <HStack gap="sm" extensions="items-center w-full">
            {channel.backgroundImage && channel.title && (
              <Avatar
                size="sm"
                url={channel.backgroundImage}
                alt={channel.title}
              />
            )}
            <VStack extensions="w-full">
              <div className="font-text w-[calc(100%-78px)] text-sm font-medium text-primary whitespace-nowrap text-ellipsis overflow-hidden">
                {channel.title}
              </div>
              <TagsContainer tags={channel.tags} />
            </VStack>
          </HStack>
          <Button variant="outline" size="sm">
            Join
          </Button>
        </HStack>
      ))}
    </AsideSection>
  );
}
